import type { HTMLProps } from "react";
// styles
import styles from "./styles.module.scss";
// components
import { ReactComponent as OutlineCross } from "assets/svg/outline-cross.svg";
import IconButton from "components/icon-button";

type Props = {
  contact: Pick<Contact, "first_name" | "last_name">;
  onClose: () => void;
  className?: string;
} & HTMLProps<HTMLDivElement>;

const InvoicingViewerTitle = ({ contact, onClose, ...props }: Props) => (
  <div {...props}>
    <IconButton
      className={styles["invoicing-viewer-title__close"]}
      onClick={onClose}
    >
      <OutlineCross />
    </IconButton>
    {!contact ? null : (
      <span className={styles["invoicing-viewer-title__contact"]}>
        {`Invoice for ${contact.first_name} ${contact.last_name}`}
      </span>
    )}
  </div>
);

export default InvoicingViewerTitle;
